import React, { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import Header from "../../../../components/Header/Header";
import Tabs from "../../../../components/Tabs/Tabs";
import mes_tab_data from "../../../../assets/mockedData/mes_tab_data";
import { savePathToLocalStorage } from "../../../../utils/helpers";

type Props = {
  title?: string;
  children: ReactNode;
  /** Na stranici analize LOT-a prikaži samo back + naslov */
  analysisMode?: boolean;
  lotLabel?: string;
};

const FlourQualityShell = ({ title, children, analysisMode, lotLabel }: Props) => {
  savePathToLocalStorage();
  return (
    <div className="mes-page flour-quality-page">
      <Header title={title || "MES - Kvaliteta brašna"} />
      <div className="main-content-flex">
        <Tabs data={mes_tab_data} />
        <div className="section mes-content fq-content">
          {!analysisMode && (
            <nav className="fq-subnav" aria-label="Kvaliteta brašna">
              <NavLink exact to="/mes/flour-analyses" activeClassName="active">
                Red čekanja
              </NavLink>
              <NavLink to="/mes/flour-analyses/history" activeClassName="active">
                Povijest testiranih
              </NavLink>
            </nav>
          )}

          {analysisMode && (
            <div className="fq-analysis-topbar">
              <NavLink to="/mes/flour-analyses" className="fq-back-link">
                ← Red čekanja
              </NavLink>
              {lotLabel && <span className="fq-analysis-lot-title">{lotLabel}</span>}
            </div>
          )}

          {children}
        </div>
      </div>
    </div>
  );
};

export default FlourQualityShell;
